module.exports = __webpack_public_path__ + "img/pic_500037.e31868e0.jpg";